import { render, staticRenderFns } from "./jinji.vue?vue&type=template&id=17868dc0&scoped=true"
import script from "./jinji.vue?vue&type=script&lang=js"
export * from "./jinji.vue?vue&type=script&lang=js"
import style0 from "./jinji.vue?vue&type=style&index=0&id=17868dc0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17868dc0",
  null
  
)

export default component.exports